import React from 'react';

const Theme = (props) => {
    return (
        <div className="theme-container">
            <span>Change Theme</span>
            {/* <div id="theme-1"
                className='bg-primary theme'
                onClick={() => props.props.handleToggle('primary')}
            ></div> */}
            {/* <div id="theme-2"
                className='bg-secondary theme'
                onClick={() => props.props.handleToggle('secondary')}
            ></div>
            <div id="theme-3"
                className='bg-success theme'
                onClick={() => props.props.handleToggle('success')}
            ></div>
            <div id="theme-4"
                className='bg-danger theme'
                onClick={() => props.props.handleToggle('danger')}
            ></div> */}
            <div id="theme-4"
                className='bg-light theme'
                onClick={() => props.props.handleToggle('light')}
            ></div>
            <div id="theme-4"
                className='bg-dark theme'
                onClick={() => props.props.handleToggle('dark')}
            ></div>
        </div>
    );
}

export default Theme;
